import React from 'react';
import { Outlet } from 'react-router-dom';
import SettingsNavigation from '../components/SettingsNavigation';

const SettingsLayout = () => (
  <div className="mx-auto w-full max-w-7xl">
    <div className="mb-6">
      <h1 className="text-3xl font-bold tracking-tight text-gray-900">Settings</h1>
      <p className="mt-1 text-sm text-gray-500">
        Manage school profile, academics, users, roles and branding.
      </p>
    </div>

    <div className="grid grid-cols-1 gap-6 lg:grid-cols-[280px_minmax(0,1fr)]">
      <aside className="h-fit rounded-2xl border border-gray-200 bg-white shadow-sm lg:sticky lg:top-0">
        <SettingsNavigation />
      </aside>

      <section className="min-w-0 rounded-2xl border border-gray-200 bg-white p-5 shadow-sm sm:p-6">
        <Outlet />
      </section>
    </div>
  </div>
);

export default SettingsLayout;
